import {h, Fragment} from "preact"
import { RangeSlider, useRangeSlider } from "@nosto/preact"
import { useState } from "preact/hooks"
import RangeInput from "./elements/RangeInput"
import Icon from "./elements/Icon"

export default function RangeFacet({ facet }) {
    const { min, max, range, updateRange } = useRangeSlider(facet.id)
    const isSelected = min !== range[0] || max !== range[1]
    const [active, setActive] = useState(true)

    return (
        <li class={`ns-sidebar-dropdown ${active ? "ns-active" : ""}`}>
            <span
                className="ns-anchor ns-d-inline-block ns-relative ns-w-100 ns-border-box"
                data-nosto-element="facet"
                onClick={() => setActive(!active)}
                aria-controls={`${facet.id}-sub-menu`}
                aria-label={`${active ? 'Collapse' : 'Expand'} ${facet.name}`}
            >
                <span className="color-text text-[18px]">{facet.name}</span>
                {active ? (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none" style={{ verticalAlign: 'middle', marginLeft: '8px' }}>
                        <path d="M18 12.5H6" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none" style={{ verticalAlign: 'middle', marginLeft: '8px' }}>
                        <path d="M12 6.21875V12.2188M12 12.2188V18.2188M12 12.2188H18M12 12.2188L6 12.2187" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                )}
            </span>
            <div class="ns-sidebar-submenu ns-d-none range-facet">
                <div className="range-facet-wrap">
                <RangeSlider id={facet.id} />
                </div>

                <div class="ns-d-flex ns-justify-content-between ns-align-items-center range-flexbox">

                    <RangeInput
                            id={`ns-${facet.id}-min`}
                            min={min}
                            max={max}
                            range={range}
                            value={range[0]}
                            onChange={e => {
                                const value = parseFloat(e.currentTarget.value) || undefined
                                updateRange([value, range[1]])
                            }}
                        />
                    to
                    <RangeInput
                            id={`ns-${facet.id}-max`}
                            min={min}
                            max={max}
                            range={range}
                            value={range[1]}
                            onChange={e => {
                                const value = parseFloat(e.currentTarget.value) || undefined
                                updateRange([range[0], value])
                            }}
                    />
                </div>
            </div>
        </li>
    )
}
